import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { PendingUserOverview, UserOverview, UserAccessType, AuthorizedUserAccessType, JobRole, User, EditUser } from '../models/user.model';
import { Tuple, SerializedTuple } from '../models/tuple.model';
import { AccessOption, ResultMessage, ModifyRelationParam } from '../models/access.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class AdministrationService {

    private readonly AccessApiBaseAddress = '../Api/Access/';
    private readonly AccessApiBaseAddress_ = '../Api/Admin/';


    constructor(private _http: HttpClient) { }

    public getAccessibleSupportTeams(): Observable<AccessOption[]> {
        // return this._http.get(this.AccessApiBaseAddress + "getAccessibleSupportTeams").share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
            return this._http.get<AccessOption[]>
            (this.AccessApiBaseAddress + 'getAccessibleSupportTeams').pipe(catchError(this.handleError));
    }

    public getAccessibleDealerGroups(): Observable<AccessOption[]> {
        // return this._http.get(this.AccessApiBaseAddress + 'getAccessibleDealerGroups').share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
            return this._http.get<AccessOption[]>
            (this.AccessApiBaseAddress + 'getAccessibleDealerGroups').pipe(catchError(this.handleError));
    }

    public getAccessibleDealers(): Observable<AccessOption[]> {
        // return this._http.get(this.AccessApiBaseAddress + 'getAccessibleDealers').share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
            return this._http.get<AccessOption[]>
            (this.AccessApiBaseAddress + 'getAccessibleDealers').pipe(catchError(this.handleError));
    }

    public getAccessibleCustomers(): Observable<AccessOption[]> {
        // return this._http.get(this.AccessApiBaseAddress + 'getAccessibleCustomers').share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getAccessibleCustomers').pipe(catchError(this.handleError));
    }

    public getAccessibleJobsites(): Observable<AccessOption[]> {
        // return this._http.get(this.AccessApiBaseAddress + 'getAccessibleJobsites').share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
            return this._http.get<AccessOption[]>
            (this.AccessApiBaseAddress + 'getAccessibleJobsites').pipe(catchError(this.handleError));
    }

    public getAccessibleEquipments(): Observable<AccessOption[]> {
        // return this._http.get(this.AccessApiBaseAddress + 'getAccessibleEquipments').share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getAccessibleEquipments').pipe(catchError(this.handleError));
    }
    public getExistingSupportTeams(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingSupportTeams', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingSupportTeams', params).pipe(catchError(this.handleError));
    }
    public getExistingDealerGroups(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingDealerGroups', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingDealerGroups', params).pipe(catchError(this.handleError));
    }
    public getExistingDealers(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingDealers', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingDealers', params).pipe(catchError(this.handleError));
    }
    public getExistingCustomers(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingCustomers', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress_ + 'getExistingCustomers', params).pipe(catchError(this.handleError));
    }
    //get existing customers for dialog_new
    public getExistingCustomers_(selectedItem: number): Observable<AccessOption[]> {     
      const params = {
        params: new HttpParams().set('Id', selectedItem.toString())
      };
      return this._http.get<AccessOption[]>
      (this.AccessApiBaseAddress_ + 'getDirectCustomersForUserNew', params).pipe(catchError(this.handleError));
  }
    public getExistingJobsites(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingJobsites', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingJobsites', params).pipe(catchError(this.handleError));
    }
    public getExistingEquipments(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingEquipments', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingEquipments', params).pipe(catchError(this.handleError));
    }
    public getExistingDealerGroupsForDealer(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingDealerGroupsForDealer', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingDealerGroupsForDealer', params).pipe(catchError(this.handleError));
    }
    public getExistingDealerGroupsForCustomer(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingDealerGroupsForCustomer', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingDealerGroupsForCustomer', params).pipe(catchError(this.handleError));
    }
    public getExistingDealersForJobsite(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingDealersForJobsite', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingDealersForJobsite', params).pipe(catchError(this.handleError));
    }
    public getExistingJobsitesForDealer(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingJobsitesForDealer', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingJobsitesForDealer', params).pipe(catchError(this.handleError));
    }
    public getExistingDealersForCustomer(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingDealersForCustomer', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingDealersForCustomer', params).pipe(catchError(this.handleError));
    }
    public getExistingCustomersForDealer(selectedItem: number): Observable<AccessOption[]> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', selectedItem.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'getExistingCustomersForDealer', { search: params }).share().map(
        //     (response: Response) => <AccessOption[]>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', selectedItem.toString())
        };
        return this._http.get<AccessOption[]>
        (this.AccessApiBaseAddress + 'getExistingCustomersForDealer', params).pipe(catchError(this.handleError));
    }
    public checkUserAccessToSupportTeam(Id: number, UserId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('UserId', UserId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkUserAccessToSupportTeam', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('UserId', UserId.toString())
        };
        return this._http.get<boolean>
        (this.AccessApiBaseAddress + 'checkUserAccessToSupportTeam', params).pipe(catchError(this.handleError));
    }

    public checkUserAccessToDealerGroup(Id: number, UserId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('UserId', UserId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkUserAccessToDealerGroup', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);

        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('UserId', UserId.toString())
        };
        return this._http.get<boolean>(this.AccessApiBaseAddress + 'checkUserAccessToDealerGroup', params).pipe(catchError(this.handleError));
    }

    public checkUserAccessToDealer(Id: number, UserId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('UserId', UserId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkUserAccessToDealer', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('UserId', UserId.toString())
        };
        return this._http.get<boolean>(this.AccessApiBaseAddress + 'checkUserAccessToDealer', params).pipe(catchError(this.handleError));
    }

    public checkUserAccessToCustomer(Id: number, UserId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('UserId', UserId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkUserAccessToCustomer', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('UserId', UserId.toString())
        };
        return this._http.get<boolean>(this.AccessApiBaseAddress + 'checkUserAccessToCustomer', params).pipe(catchError(this.handleError));
    }

    public checkUserAccessToJobsite(Id: number, UserId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('UserId', UserId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkUserAccessToJobsite', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('UserId', UserId.toString())
        };
        return this._http.get<boolean>(this.AccessApiBaseAddress + 'checkUserAccessToJobsite', params).pipe(catchError(this.handleError));
    }

    public checkUserAccessToEquipment(Id: number, UserId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('UserId', UserId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkUserAccessToEquipment', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('UserId', UserId.toString())
        };
        return this._http.get<boolean>(this.AccessApiBaseAddress + 'checkUserAccessToEquipment', params).pipe(catchError(this.handleError));
    }

    public checkDealerAccessToDealerGroup(Id: number, DealerId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('DealerId', DealerId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkDealerAccessToDealerGroup', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('DealerId', DealerId.toString())
        };
        return this._http.get<boolean>
        (this.AccessApiBaseAddress + 'checkDealerAccessToDealerGroup', params).pipe(catchError(this.handleError));
    }

    public checkDealerAccessToCustomer(Id: number, DealerId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('DealerId', DealerId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkDealerAccessToCustomer', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('DealerId', DealerId.toString())
        };
        return this._http.get<boolean>
        (this.AccessApiBaseAddress + 'checkDealerAccessToCustomer', params).pipe(catchError(this.handleError));
    }

    public checkDealerAccessToJobsite(Id: number, DealerId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('DealerId', DealerId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkDealerAccessToJobsite', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('DealerId', DealerId.toString())
        };
        return this._http.get<boolean>
        (this.AccessApiBaseAddress + 'checkDealerAccessToJobsite', params).pipe(catchError(this.handleError));
    }

    public checkDealerGroupAccessToCustomer(Id: number, DealerGroupId: number): Observable<boolean> {
        // const params: URLSearchParams = new URLSearchParams();
        // params.set('Id', Id.toString());
        // params.set('DealerGroupId', DealerGroupId.toString());
        // return this._http.get(this.AccessApiBaseAddress + 'checkDealerGroupAccessToCustomer', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('Id', Id.toString()).set('DealerGroupId', DealerGroupId.toString())
        };
        return this._http.get<boolean>
        (this.AccessApiBaseAddress + 'checkDealerGroupAccessToCustomer', params).pipe(catchError(this.handleError));
    }

    public modifyUserAccessToSupportTeam(Id: number, UserId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = UserId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyUserAccessToSupportTeam', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyUserAccessToSupportTeam', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyUserAccessToDealerGroup(Id: number, UserId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = UserId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyUserAccessToDealerGroup', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyUserAccessToDealerGroup', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyUserAccessToDealer(Id: number, UserId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = UserId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyUserAccessToDealer', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyUserAccessToDealer', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyUserAccessToCustomer(Id: number, UserId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = UserId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyUserAccessToCustomer', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyUserAccessToCustomer', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyUserAccessToJobsite(Id: number, UserId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = UserId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyUserAccessToJobsite', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyUserAccessToJobsite', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyUserAccessToEquipment(Id: number, UserId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = UserId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyUserAccessToEquipment', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyUserAccessToEquipment', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyDealerAccessToDealerGroup(Id: number, DealerId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = DealerId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyDealerAccessToDealerGroup', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyDealerAccessToDealerGroup', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyDealerAccessToCustomer(Id: number, DealerId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = DealerId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyDealerAccessToCustomer', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyDealerAccessToCustomer', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyDealerAccessToJobsite(Id: number, DealerId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = DealerId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyDealerAccessToJobsite', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyDealerAccessToJobsite', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }

    public modifyDealerGroupAccessToCustomer(Id: number, DealerGroupId: number, remove: boolean): Observable<ResultMessage> {
        const params: ModifyRelationParam = new ModifyRelationParam();
        params.LeftId = Id;
        params.RightId = DealerGroupId;
        params.Remove = remove;
        return this._http.post<ResultMessage>
        (this.AccessApiBaseAddress + 'modifyDealerGroupAccessToCustomer', params).pipe(catchError(this.handleError));
        // return this._http.post(this.AccessApiBaseAddress + 'modifyDealerGroupAccessToCustomer', params).share().map(
        //     (response: Response) => <ResultMessage>response.json()).catch(this.handleError);
    }


    //check duplicates in customers in the 
    public checkDealerGrouphasDuplicatedCustomers(customerId: number, DealerId: number, DealerGroupId:number): Observable<boolean> {
      // const params: URLSearchParams = new URLSearchParams();
      // params.set('Id', Id.toString());
      // params.set('DealerId', DealerId.toString());
      // return this._http.get(this.AccessApiBaseAddress + 'checkDealerAccessToCustomer', { search: params }).share().map(
      //     (response: Response) => <boolean>response.json()).catch(this.handleError);
      const params = {
        params: new HttpParams().set('customerId', customerId.toString()).set('DealerId', DealerId.toString()).set('DealerGroupId', DealerGroupId.toString())
      };
      return this._http.get<boolean>
      (this.AccessApiBaseAddress + 'checkDealerGroupHasSameCustomer', params).pipe(catchError(this.handleError));
  }


    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}
